import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';

import { DEFAULT_LOGOUT_TIMEOUT } from '../const';
import { updateLogoutTime } from './updateLogoutTime';

type ReturnType = (enable: boolean) => void;

export const useLocationChange = (): ReturnType => {
  const [enabled, setEnabled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;
    const time = dayjs().add(DEFAULT_LOGOUT_TIMEOUT);
    updateLogoutTime(time);
  }, [enabled, location.pathname]);

  return setEnabled;
};
